var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ellipsis-text-wrapper"},[_c('div',{ref:"textEllipsis",staticClass:"ellipsis-text",style:({
      height: _vm.showExpand ? ((this.lineHeight * this.lineClamp) + "px") : null,
      lineHeight: ((this.lineHeight) + "px")
    })},[_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.text),expression:"text"}]})]),(_vm.showExpand)?_c('div',{staticClass:"more-text",style:({
      height: ((this.lineHeight) + "px"),
      lineHeight: ((this.lineHeight) + "px")
    }),on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleExpandAll($event)}}},[_vm._v(" "+_vm._s(_vm.expandChar)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }